import React from "react";

import {Chip, Tooltip, Box} from "@mui/material";
import Face5Icon from "@mui/icons-material/Face5";
import FaceIcon from "@mui/icons-material/Face";
import Face3Icon from "@mui/icons-material/Face3";

import '../../css/App.css';
import ChildDetailTooltipLabel from "./ChildDetailTooltipLabel";
import {buildChildBiographicalDetails, buildChildDisplayName} from "../../helpers/SessionHelper";

export default function ChildDetailsChip({child, compactView = true, onChildDetailsDrilledInto, showChildDetailLabel = true, containsHeader = true, serviceType, attendanceReport, showHistory}) {

    const childContainerStyle = {
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'center',
        overflow: 'hidden',
        marginLeft: containsHeader ? '-0.5rem' : '0.1rem',
        marginRight: showChildDetailLabel ? '0.1rem' : '-0.6rem',
        marginBottom: compactView ? '0' : '0.2rem',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    };

    const childChipStyle = {
        display: 'flex',
        overflow: 'hidden',
        marginLeft: '0.1rem',
        marginRight: showChildDetailLabel ? '0.1rem': '-0.8rem',
        width: showChildDetailLabel ? '100%' : '60%',
        backgroundColor: compactView ? 'rgba(255, 255, 255, 0.8)' : 'white',
        ...(!showHistory && {border: '0.063rem solid black', marginLeft: '0.5rem'})
    };

    const childIcon = (gender) => {
        let icon = <Face5Icon />;

        if (gender === 'MALE') {
            icon = <FaceIcon />;
        } else if (gender === 'FEMALE') {
            icon = <Face3Icon />;
        }

        return icon;
    }

    const buildLabel = () => {
        if (showHistory) {
            return buildChildBiographicalDetails(child);
        }

        return buildChildDisplayName(child);
    };

    const childIconInChip = <Box sx={{display: 'flex', paddingLeft: '0.5rem'}}>{childIcon(child.gender)}</Box>

    return (
      <Box sx={childContainerStyle}>
          <Tooltip disableFocusListener arrow
                   title={<ChildDetailTooltipLabel {...{
                       child,
                       onChildDetailsDrilledInto,
                       serviceType,
                       attendanceReport,
                       showHistory
                   }} />}>
              <Chip icon={childIconInChip} size={compactView ? "small" : "medium"} label={showChildDetailLabel ? buildLabel() : null} sx={childChipStyle}/>
          </Tooltip>
      </Box>
    );
}
